export default "__VITE_ASSET__BPqLQKYS__"